import styled from 'styled-components'
import { GRAY2, SECONDARY_TEXT, GRAY4 } from 'constants/colors'
import { StyledSelectInput } from 'components/common/Inputs/styles'

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  thead th {
    &:first-child {
      border-top-left-radius: 8px;
    }

    &:last-child {
      border-top-right-radius: 8px;
    }
  }

  tbody tr:last-child {
    th,
    td {
      &:first-child {
        border-bottom-left-radius: 8px;
      }

      &:last-child {
        border-bottom-right-radius: 8px;
      }
    }
  }

  .active {
    background: ${GRAY4};
  }

  th,
  td {
    padding: 14px 16px;
    border: solid ${GRAY2};
    border-width: 1px 0;

    &:first-child {
      border-left-width: 1px;
    }

    &:last-child {
      border-right-width: 1px;
    }

    .MuiTextField-root {
      margin: 0;
    }
  }

  ${StyledSelectInput},
  .MuiTextField-root {
    margin: 0;
    display: block;
  }
`

export const StyledSnapshotLabel = styled.div`
  color: ${SECONDARY_TEXT};
  background: ${GRAY2};
  padding: 10px 14px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
`
